import gridSideBarConfig from '@/grid/gridSideBarConfig'
import {
    GetContextMenuItemsParams,
    GridReadyEvent,
    MenuItemDef,
    RowClickedEvent,
    SelectionChangedEvent
} from '@ag-grid-enterprise/all-modules'
import { Component, Vue } from 'vue-property-decorator'
import { CrudModelBase, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { AgGridOptions, AgGridRowModelType, IModeView } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

@Component
export default class BaseCrudClientSideComponent<T> extends Vue {
    state: CrudModelBase<T>

    constructor() {
        super()
        this.state = initialCrudModelBaseState<T>()
    }

    created(): void {
        this.state.gridOptions = {
            paginationPageSize: 20,
            paginationAutoPageSize: false,
            sideBar: gridSideBarConfig,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: this.onGridReady,
            onRowClicked: this.onRowClicked,
            onSelectionChanged: this.onSelectionChanged,
            rowHeight: this.rowHeight,
            rowModelType: AgGridRowModelType.CLIENT_SIDE
        }
    }

    get gridOptions(): AgGridOptions {
        return this.state.gridOptions
    }

    get visibleSidePanel(): boolean | undefined {
        return this.state.visibleSidePanel
    }

    onRowClicked({ node }: RowClickedEvent) {
        this.state.clickedRow = node.data
        this.state.visibleSidePanel = true
    }

    get rowHeight(): number {
        return this.state?.viewOptions?.modeView?.size
    }

    onGridReady({ api }: GridReadyEvent): void {
        this.state.gridApi = api

        if (this.state.columnsDef) {
            this.state.gridApi.setColumnDefs(this.state.columnsDef)
        }
        if (this.state.rowData) {
            this.state.gridApi.setRowData(this.state.rowData)
        }
    }

    setRowData(rowData: T[]): void {
        this.state.gridApi?.deselectAll()
        this.state.rowData = rowData
    }
    closeSidePanel(): void {
        if (this.state.visibleSidePanel) {
            this.state.visibleSidePanel = false
        }
    }
    onSelectionChanged({ api }: SelectionChangedEvent): void {
        this.state.selectedRows = api.getSelectedRows()
    }

    showModal(title: string, selected: any, modalReference: any): void {
        if (this.state.visibleSidePanel) {
            this.state.visibleSidePanel = false
        }
        this.state.actionTitle = title
        modalReference.show([selected])
    }

    changedPageSize(pageSize: number): void {
        this.state.gridApi?.paginationSetPageSize(pageSize)
    }

    changedMode(modeView: IModeView): void {
        this.state = {
            ...this.state,
            viewOptions: {
                ...this.state.viewOptions,
                modeView: {
                    ...this.state.viewOptions.modeView,
                    ...modeView
                }
            }
        }
        if (this.state.gridApi) {
            GridUtils.changeRowHeightGrid(this.state.gridApi, modeView.size)
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        return []
    }
}
